export default __webpack_public_path__ + "static/iphone-se-mock-bd88cb4874c07118ebd8121730f30aab.png";